export default __webpack_public_path__ + "static/media/hot-9.2481ede4.png";